import { type ResolvedOrdinaryEvent } from '@hedepy/common/schemas/modules/event/cart'

const getCustomerType = (event: { voucherType: string; companyEventQuotaId?: number } | ResolvedOrdinaryEvent) => {
  const isB2B =
    // only in POST /event endpoint
    ('voucherType' in event && event.voucherType === 'b2b') ||
    // response from /events endpoint
    ('companyEventQuotaId' in event && Boolean(event.companyEventQuotaId)) ||
    // response from resolve/checkout endpoints
    ('discountedBy' in event && event.discountedBy?.type === 'b2b') ||
    ('discountedBy' in event && event.discountedBy?.type === 'voucher' && event.discountedBy?.voucherType === 'b2b')

  return {
    isB2B,
    isB2C: !isB2B,
  }
}

export default getCustomerType
